/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient, HttpProgressEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { uploadProgress } from '@assetaccountant/core/utils/upload-progress';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AttachmentReadModel } from '../models/attachment-read-model';
import { AddAttachmentLinkCommand } from '../models/attachments/add-attachment-link.command';
import { CreateAttachmentCommand } from '../models/attachments/create-attachment.command';
import { DeleteAttachmentCommand } from '../models/attachments/delete-attachment.command';
import { DownloadAttachmentCommand } from '../models/attachments/download-attachment.command';
import { EditAttachmentLinkCommand } from '../models/attachments/edit-attachment-link.command';
import { ListAttachmentQuery } from '../models/attachments/list-attachment.query';
import { OperationResponse } from '../models/generic/operation-response';

@Injectable({
  providedIn: 'root',
})
export class AttachmentApi {
  constructor(private http: HttpClient) {}

  addLink(command: AddAttachmentLinkCommand): Observable<OperationResponse<AttachmentReadModel>> {
    return this.http.post<OperationResponse<AttachmentReadModel>>(
      `${environment.servicesApiUrl}/api/v1/${command.objectType}/${command.objectId}/attachments/addlink`,
      command,
    );
  }

  create(
    command: CreateAttachmentCommand,
  ): Observable<HttpProgressEvent | OperationResponse<AttachmentReadModel[]>> {
    const formData = new FormData();
    command.file.forEach(item => {
      formData.append('file', item, item.name);
    });

    return this.http
      .post<
        OperationResponse<AttachmentReadModel[]>
      >(`${environment.servicesApiUrl}/api/v1/${command.objectType}/${command.objectId}/attachments`, formData, { reportProgress: true, observe: 'events' })
      .pipe(uploadProgress());
  }

  delete(command: DeleteAttachmentCommand): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v1/${command.objectType}/${command.objectId}/attachments/${command.attachmentId}`,
    );
  }

  download(command: DownloadAttachmentCommand): Observable<Blob> {
    return this.http.get(
      `${environment.servicesApiUrl}/api/v1/${command.objectType}/${command.objectId}/attachments/${command.attachmentId}/download`,
      { responseType: 'blob' },
    );
  }

  editLink(command: EditAttachmentLinkCommand): Observable<OperationResponse<AttachmentReadModel>> {
    return this.http.put<OperationResponse<AttachmentReadModel>>(
      `${environment.servicesApiUrl}/api/v1/${command.objectType}/${command.objectId}/attachments/${command.attachmentId}/editlink`,
      command,
    );
  }

  list(query: ListAttachmentQuery): Observable<OperationResponse<AttachmentReadModel[]>> {
    return this.http.get<OperationResponse<AttachmentReadModel[]>>(
      `${environment.servicesApiUrl}/api/v1/${query.objectType}/${query.objectId}/attachments`,
    );
  }
}
